<template>
  <div class="search widget">
    <div class="search-wrapper left-line">
      <div class="search-left">
        <strong class="title">有害生物信息检索</strong>
        <div class="input-wrapper">
          <input v-model="keyword" v-on:keyup.enter="search" placeholder="输入中文名或学名" /><span v-on:click="search" class="btn">搜索</span>
        </div>
      </div>
      <div class="search-right">
        <img src="@/assets/images/refresh.png" /><span>刷新</span>
      </div>
    </div>
  </div>
</template>

<script>
  import './search.scss'
  export default {
    name: 'Search',
    data(){
      return {
        keyword:""
      }
    },
    methods: {
      search(){
        this.$emit("search",this.keyword)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/base/search/search.vue